import { useState, useRef } from 'react';
import './index.css';
import { useSnackbar } from 'notistack';

import Show from '../../utility/Show';
import FormError from '../../utility/FormError';

import { ReactComponent as WalkspanLogo } from '../../assets/walkspan-logo-2.svg';

import { isValidEmail, setLSData, convertToSlug } from '../../services';
import { getProfilebyEmail, associateAgent } from '../../api';
import { CircularLoader } from '../Loaders';

const EmailAuthGate = ({ state, actions, dispatch }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { userDetails, errorMessage } = state;
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const formRef = useRef();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const formDataObj = Object.fromEntries(formData.entries());
    const email = formDataObj['email'];
    const company = formDataObj['company'];

    if (!isValidEmail(email)) {
      showFormError('Please enter a valid email address.')
      return;
    }

    try {
      setIsloading(true);
      const payload = { email: email, company_slug: (company && convertToSlug(company))}
      const response = await associateAgent(payload);

      if (response?.status === 200){
        const profile = await getProfilebyEmail(response?.data?.email);
        if (profile?.status === 200) {
          setLSData('Agent-Email', response?.data?.email);
          dispatch({ type: 'SET_LS_EMAIL', payload: response?.data?.email });
          setLSData('Company-Slug', convertToSlug(profile?.data?.company) || "private-individual");
          setIsSubmitted(true);
          dispatch({ type: 'SET_SHOW_EMAIL_AUTH_GATE', payload: false });
        } else {
          showErrorMessage(profile);
        }
      } else {
        if (response?.status !== 200) {
          showErrorMessage(response);
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsloading(false);
    }
  };

  const showFormError = (message) => {
    enqueueSnackbar(message, {
      variant: 'warning',
      preventDuplicate: true,
      autoHideDuration: 2000,
      anchorOrigin: { vertical: 'top', horizontal: 'right' },
    });
  };

  const showErrorMessage = (data) => {
    const message =
      data?.response?.data?.error ||
      data?.data?.message ||
      'Subscription error';
    dispatch({ type: 'SET_SHOW_ERROR_MODAL', payload: true });
    dispatch({ type: 'SET_ERROR_MESSAGE', payload: message });
  }

  return (
    <div className="email-gate-container">
      <div className="email-gate-card">
        <WalkspanLogo />
        <div>To continue using our platform, please enter your email</div>
        <form ref={formRef} onSubmit={handleSubmit}>
          <Show.When isTrue={errorMessage && !isSubmitted}>
            <FormError
              error={errorMessage}
              textColor='#f14c4c'
              className='!grid-cols-1'
            />
          </Show.When>
          <input
            type='text'
            name='email'
            placeholder='Enter your email'
            // onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type='text'
            name='company'
            placeholder='Enter company name'
            // onChange={(e) => setEmail(e.target.value)}
          />
          <button type='submit' disabled={isLoading}>
            <Show>
              <Show.When isTrue={isLoading}>
                <CircularLoader size="22.391px" className="flex justify-center" />
              </Show.When>
              <Show.Else>
                Submit
              </Show.Else>
            </Show>
          </button>
        </form>
      </div>
    </div>
  )
}

export default EmailAuthGate;